module.exports = __webpack_public_path__ + "img/bg.ea7f5a53.png";